import { render } from "./CompoStep2.vue?vue&type=template&id=731f3b45"
import script from "./CompoStep2.vue?vue&type=script&lang=js"
export * from "./CompoStep2.vue?vue&type=script&lang=js"

import "./CompoStep2.vue?vue&type=style&index=0&id=731f3b45&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__